import { render, staticRenderFns } from "./ValueChange.vue?vue&type=template&id=cf4e5c3c&scoped=true&"
import script from "./ValueChange.vue?vue&type=script&lang=js&"
export * from "./ValueChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4e5c3c",
  null
  
)

export default component.exports